import { createOptionNode } from './composite';
import { optionsFactoryKeys } from './config';

class OptionTreeManager {
  constructor(schema, type, sortStrategy) {
    this._schema = schema;
    this._root = createOptionNode({ type, sortStrategy });
  }

  add(entries, value) {
    const targetNode = this._ensurePath(entries);
    targetNode.add({ value });
  }

  _ensurePath(entries) {
    let current = this._root;

    entries.forEach((entry, index) => {
      if (current.isComposite()) {
        const { key, value } = entry;

        const { type, labelFn, sortStrategy } = this._schema[key];

        const groupData = {
          label: labelFn(value),
          level: index + 1,
          groupValue: value,
          sortOrder: Number(value),
        };

        current = current.getOrCreate(value, () =>
          createOptionNode({ type, groupData, sortStrategy })
        );
      }
    });

    return current;
  }

  normalize() {
    return this._root.normalize();
  }
}

export const createOptionTreeManager = ({
  schema,
  type = optionsFactoryKeys.composite,
  sortStrategy,
}) => new OptionTreeManager(schema, type, sortStrategy);
